import { Button, Modal } from 'antd';
import { useWorkorderDetailContext } from '../../../WorkorderDetailProvider';
import {
  ErrorItemQuotation,
  useWorkOrderItemBatchRemove,
} from '@/core/domain/workorder/WorkOrdersItems/WorkOrdersItems.hooks';
import { useDisclosure } from '@/hooks';
import { mapWorkOrderItemFieldErrors } from '@/utils/functions/buildItemErrorsList';

export default function WorkOrderItemBatchRemove() {
  const {
    items: { selectedItemsRows, setSelectedItemsRows },
    complement: { data: complement },
  } = useWorkorderDetailContext();

  const batchRemove = useWorkOrderItemBatchRemove();
  const [opened, action] = useDisclosure(false);

  if (!selectedItemsRows.length) return null;

  const handleConfirm = async () => {
    if (!complement?.id) return;

    try {
      await batchRemove.mutateAsync({
        complementId: complement.id,
        items: selectedItemsRows.map((item) => ({
          ...item,
          workOrderItemId: item.id,
          isItemRejectedByCustomer: false,
        })),
      });
    } catch (error) {
      const axiosError = error as ErrorItemQuotation;
      const errorsList = mapWorkOrderItemFieldErrors(axiosError, {
        items: selectedItemsRows,
      });

      setSelectedItemsRows((prev) =>
        prev.filter((item) =>
          errorsList.some((error) => error.itemId === item.id),
        ),
      );
    }

    action.close();
  };

  return (
    <>
      <Button danger onClick={action.open} style={{ marginRight: 12 }}>
        Remover múltiplos
      </Button>

      <Modal
        title="Remover itens selecionados"
        open={opened}
        okText="Remover"
        okType="danger"
        confirmLoading={batchRemove.isLoading}
        onOk={handleConfirm}
        onCancel={action.close}
      >
        <p>
          {`Você está prestes a remover `}
          <strong>{selectedItemsRows.length}</strong> itens do orçamento.
        </p>

        <strong>Esta ação não poderá ser desfeita.</strong>
      </Modal>
    </>
  );
}
